(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hausiel-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bar = document.querySelector('[data-hausiel-sticky-atc]');
  if (!bar || bar.dataset.bound === 'true') return;
  bar.dataset.bound = 'true';

  const stickyButton = bar.querySelector('.hausiel-sticky-atc__button');
  const stickyPrice = bar.querySelector('[data-hausiel-sticky-price]');
  let observedButton = null;
  let buttonObserver = null;
  let footerObserver = null;
  let mainPassed = false;
  let footerInView = false;

  const getMain = () => {
    const info = document.querySelector('product-info');
    return {
      info,
      button: info?.querySelector('.product-form__submit'),
      form: info?.querySelector('form[data-type="add-to-cart-form"]')
    };
  };

  const getVisiblePrice = () => {
    const priceRoot = document.querySelector('product-info [id^="price-"]');
    if (!priceRoot) return null;
    const priceBox = priceRoot.querySelector('.price') || priceRoot;
    const selector = priceBox.classList.contains('price--on-sale')
      ? '.price__sale .price-item--sale'
      : '.price__regular .price-item--regular';
    const primary = priceRoot.querySelector(selector);
    const fallback = priceRoot.querySelector('.price-item--sale, .price-item--regular');
    return (primary || fallback)?.textContent?.replace(/\s+/g, ' ').trim() || null;
  };

  const setVisibility = () => {
    const drawerOpen = document.querySelector('cart-drawer.active');
    const visible = mainPassed && !footerInView && !drawerOpen;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    stickyButton.tabIndex = visible ? 0 : -1;
  };

  const sync = () => {
    const main = getMain();
    if (!main.button) return;
    stickyButton.disabled = main.button.disabled || main.button.getAttribute('aria-disabled') === 'true';
    const soldOut = main.button.querySelector('.sold-out-message:not(.hidden)');
    const normal = [...main.button.querySelectorAll('span')].find((span) => !span.classList.contains('hidden') && !span.classList.contains('sold-out-message') && !span.classList.contains('loading__spinner'));
    const label = (soldOut || normal)?.textContent?.replace(/\s+/g, ' ').trim();
    if (label) stickyButton.textContent = label;
    const price = getVisiblePrice();
    if (price && stickyPrice) stickyPrice.textContent = price;
  };

  const bindObservers = () => {
    const mainButton = getMain().button;
    if (mainButton && mainButton !== observedButton) {
      buttonObserver?.disconnect();
      observedButton = mainButton;
      buttonObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        mainPassed = !entry.isIntersecting;
        setVisibility();
      }, { threshold: .05 });
      buttonObserver.observe(mainButton);
    }

    footerObserver?.disconnect();
    const footer = document.querySelector('footer, .shopify-section-group-footer-group');
    if (footer) {
      footerObserver = new IntersectionObserver((entries) => {
        footerInView = entries[0].isIntersecting;
        setVisibility();
      }, { threshold: .01 });
      footerObserver.observe(footer);
    }
  };

  const mainMutation = new MutationObserver(() => sync());
  const mainButton = getMain().button;
  if (mainButton) mainMutation.observe(mainButton, { attributes: true, subtree: true, childList: true, attributeFilter: ['disabled','aria-disabled','class'] });

  const drawer = document.querySelector('cart-drawer');
  const drawerMutation = drawer ? new MutationObserver(setVisibility) : null;
  if (drawer && drawerMutation) drawerMutation.observe(drawer, { attributes: true, attributeFilter: ['class'] });

  stickyButton.addEventListener('click', () => {
    sync();
    const main = getMain();
    if (!stickyButton.disabled && main.form) main.form.requestSubmit();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(() => { sync(); bindObservers(); }));
  }
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(() => { sync(); bindObservers(); }));
  window.addEventListener('scroll', setVisibility, { passive: true });
  sync();
  bindObservers();
  setVisibility();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
